import styled, { keyframes } from 'styled-components'


//
//  Default
//
const One = keyframes`
0% {
  transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
}
100% {
  transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
}
`

const Two = keyframes`
0% {
  transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
}
100% {
  transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
}
`

const Three = keyframes`
0% {
  transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
}
100% {
  transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
}
`

export const PageLoadingWrap = styled.div`
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10001;

  .loader {
    position: absolute;
    top: calc(50% - 60px);
    left: calc(50% - 60px);
    width: 120px;
    height: 120px;
    border-radius: 50%;
    perspective: 800px;
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;  
  }

  .inner.one {
    left: 0%;
    top: 0%;
    animation: ${One} 1s linear infinite;
    border-bottom: 5px solid #1C262B;
  }

  .inner.two {
    right: 0%;
    top: 0%;
    animation: ${Two} 1s linear infinite;
    border-right: 5px solid #1C262B;
  }

  .inner.three {
    right: 0%;
    bottom: 0%;
    animation: ${Three} 1s linear infinite;
    border-top: 5px solid #1C262B;
  }
`


//
// House
//
const Dot = props => keyframes`
  from {
    background-color: transparent;
  }
  33% {
    background-color: transparent;
  }
  37.5% {
    background-color: ${props.color ? props.color : '#fff'};
  }
  83% {
    background-color: ${props.color ? props.color : '#fff'};
  }
  87.5% {
    background-color: transparent;
  }
  to {
    background-color: transparent;
  }
`

const LeftLine = keyframes`
  from {
    left: 0;
    width: 0;
  }
  12.5% {
    left: 0;
    width: 124px;
  }
  50% {
    left: 0;
    width: 124px;
  }
  62.5% {
    left: 124px;
    width: 0;
  }
  to {
    left: 124px;
    width: 0;
  }
`

const LeftUpLine = keyframes`
  from {
    top: 208px;
    height: 0;
  }
  12.5% {
    top: 208px;
    height: 0;
  }
  17% {
    top: 178px;
    height: 30px;
  }
  62.5% {
    top: 178px;
    height: 30px;
  }
  67% {
    top: 178px;
    height: 0;
  }
  to {
    top: 208px;
    height: 0;
  }
`

const LeftAngleLine = keyframes`
  from {
    top: 182px;
    left: 116px;
    height: 0;
  }
  17% {
    top: 182px;
    left: 116px;
    height: 0;
  }
  25% {
    top: 144px;
    left: 131px;
    height: 48px;
  }
  67% {
    top: 144px;
    left: 131px;
    height: 48px;
  }
  75% {
    top: 153px;
    left: 147px;
    height: 0;
  }
  to {
    top: 153px;
    left: 147px;
    height: 0;
  }
`

const RightAngleLine = keyframes`
  from {
    top: 152px;
    left: 144px;
    height: 0;
  }
  25% {
    top: 152px;
    left: 144px;
    height: 0;
  }
  33% {
    top: 144px;
    left: 161px;
    height: 48px;
  }
  75% {
    top: 144px;
    left: 161px;
    height: 48px;
  }
  83% {
    top: 182px;
    left: 176px;
    height: 0px;
  }
  to {
    top: 182px;
    left: 176px;
    height: 0px;
  }
`

const RightUpLine = keyframes`
  from {
    top: 178px;
    height: 0;
  }
  33% {
    top: 178px;
    height: 0;
  }
  37.5% {
    top: 178px;
    height: 30px;
  }
  83% {
    top: 178px;
    height: 30px;
  }
  87.5% {
    top: 208px;
    height: 0px;
  }
  to {
    top: 208px;
    height: 0px;
  }
`

const RightLine = keyframes`
  from {
    right: 124px;
    width: 0;
  }
  37.5% {
    right: 124px;
    width: 0;
  }
  50% {
    right: 0;
    width: 124px;
  }
  87.5% {
    right: 0;
    width: 124px;
  }
  to {
    right: 0;
    width: 0;
  }
`

export const HouseWrap = styled.div`
  width: 300px;
  height: 300px;
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translate(-50%, 0);

  .leftLine {
    position: absolute;
    top: 200px;
    left: 0;
    height: 8px;
    width: 124px;
    background-color: ${props => props.color ? props.color : '#fff'};
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    animation: ${LeftLine} 1.5s infinite linear;
  }

  .leftUpLine {
    position: absolute;
    top: 178px;
    left: 116px;
    width: 8px;  
    height: 0;
    background-color: ${props => props.color ? props.color : '#fff'};
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    animation: ${LeftUpLine} 1.5s infinite linear;
  }

  .leftAngleLine {
    position: absolute;
    top: 180px;
    left: 116px;
    width: 8px;
    height: 0;
    background-color: ${props => props.color ? props.color : '#fff'};
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    transform: rotate(-132deg);
    animation: ${LeftAngleLine} 1.5s infinite linear;
  }

  .rightAngleLine {
    position: absolute;
    top: 150px;
    left: 149px;
    width: 8px;
    height: 0;
    background-color: ${props => props.color ? props.color : '#fff'};
    transform: rotate(132deg);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    animation: ${RightAngleLine} 1.5s infinite linear;
  }

  .rightUpLine {
    position: absolute;
    top: 178px;
    right: 116px;
    width: 8px;  
    height: 0;
    background-color: ${props => props.color ? props.color : '#fff'};
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    animation: ${RightUpLine} 1.5s infinite linear;
  }

  .rightLine {
    position: absolute;
    top: 200px;
    right: 0px;
    height: 8px;
    width: 124px;
    background-color: ${props => props.color ? props.color : '#fff'};
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    animation: ${RightLine} 1.5s infinite linear;
  }

  .dot {
    position: absolute;
    top: 192px;
    left: 143px;
    height: 14px;
    width: 14px;
    background-color: transparent;
    border-radius: 25px;
    animation: ${props => `${Dot(props)} 1.5s infinite linear`};
  }
`




//
// Logo
//

const HeartBeat = keyframes`
  0% {
    transform: scale( .75);
  }
  15% {
    transform: scale( 1);
  }
  30% {
    transform: scale( .75);
  }
  45% {
    transform: scale( 1);
  }
  60% {
    transform: scale( .75);
  }
  100% {
    transform: scale( .75);
  }
`

export const LoadingWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > p {
    margin-top: 10px;
  }
`

export const LogoHeartBeat = styled.div`
  text-align: center;

  > svg {
    animation: ${HeartBeat} 1s infinite ease-out;
  }

`



// WEBPACK FOOTER //
// ./client/components/Loading/styled.js